// common
require('./vendor');
require('./bootstrap');

// Media query
require('./lib/initial');
require('./lib/window_size_helper');
require('./lib/offcanvas');
require('./lib/megamenu');
require('./lib/sliders');

// shop
require('./lib/promise_queue');
require('./lib/forms');

require('./lib/search');
require('./lib/filter');

// cart
require('./lib/modal_message');
require('./lib/cart/cart_add');
require('./lib/cart/cart_add_or_delete_services');
require('./lib/cart/cart_add_service');
require('./lib/cart/cart_init');
require('./lib/cart/cart_remove');
require('./lib/cart/cart_update');

// main
require('./index');
require('./cookies');
